export default "__VITE_ASSET__2TcREiLk__"